const Pack = ({
  children,
  idSection = null,
  idContainer = null,
  dataComponent = null,
  sectionInlineStyle = null,
  articleInlineStyle = null,
}) => {
  return (
    <section
      className="section"
      id={idSection}
      data-component={dataComponent}
      style={sectionInlineStyle}
    >
      <article
        className="container"
        id={idContainer}
        style={articleInlineStyle}
      >
        {children}
      </article>
    </section>
  );
};

export default Pack;
